export const SILOREAL_LOCALSTORAGE_KEY = 'IOF.WEB.GLOBAL_STORE';
